import React, { useState, useEffect } from "react";
import styled from "styled-components";
import TickNormal from "../../../assets/img/icons/tickNormal.svg";
import crossNormal from "../../../assets/img/icons/crossNormal.svg";
import Input from "../../Common/Components/Input";
import { getQueryParam } from "utils";
import EditIcon from "../../../assets/img/icons/Edit.svg";
import { updateEditionSubject } from "../Edition/actions";
import store, { RootState } from "store";
import { Skeleton } from "antd";
import { ASSET_TYPE } from "../../../constants/index";
import { useSelector } from "react-redux";
import { IVersion } from "../interfaces";
import { Tooltip, Typography } from "antd";

interface EmailCardProps {
  id?: any;
  draftName: string; // draft name
  draftTitle: string; // subject line
  curatedArticlesCount: String;
  assetType?: String;
  editable?: boolean;
}
export default function EmailTextArea(props: EmailCardProps) {
  const [editMode, setEditMode] = useState(false);
  const [draftName, setDraftName] = useState(props?.draftName);
  const [draftTitle, setDraftTitle] = useState(props?.draftTitle);
  const draftEditions: IVersion[] = useSelector(
    (state: RootState) => state.assetWithoutCampaignDetails.draftEditions
  );

  // const { draftName, draftTitle } = props;
  const [inputValue, setInputValue] = useState(props.draftTitle);
  const [nameChangeLoading, setNameChangeLoading] = useState(false);
  const assetId = props.id;

  const [ellipsisState, setEllipsistate] = useState(false);
  const { Paragraph } = Typography;
  console.log("ELLIPSIS: ", ellipsisState);
  const setItemNameHandler = () => {
    let asset_id: any;
    if (assetId) {
      asset_id = assetId;
    } else {
      asset_id = getQueryParam("asset_id");
    }
    let asset_name: any;
    if (inputValue !== undefined) {
      asset_name = inputValue;
    } else {
      asset_name = draftTitle;
    }
    updateSubject();
  };

  const handleInputKeyUp = (e: any) => {
    if (e.key === "Enter") {
      if (draftTitle !== inputValue) {
        if (inputValue?.trim() !== "") setItemNameHandler();
      } else {
        setEditMode(false);
      }
    }
  };

  const setEditModeMethod = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setInputValue(props.draftTitle);
    setEditMode(true);
  };
  const stopBubbling = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const saveMethod = () => {
    updateSubject();
  };
  const cancelMethod = () => {
    setEditMode(false);
    setInputValue(props.draftTitle);
  };

  const updateSubject = () => {
    setNameChangeLoading(true);
    // setInputValue(inputValue);
    updateEditionSubject(assetId, inputValue, setNameChangeLoading);
    setEditMode(false);
  };

  useEffect(() => {
    setNameChangeLoading(false);
    setInputValue(props.draftTitle);
  }, [props.draftTitle]);

  return (
    <div>
      <div
        style={{
          cursor: "pointer",
        }}
        className="d-flex flex-column"
      >
        <DraftName>{props.draftName}</DraftName>
        {nameChangeLoading && <Skeleton.Input active={true} />}
        {!nameChangeLoading && (
          <>
            {editMode ? (
              <div onClick={(e) => stopBubbling(e)} style={{ width: "100%" }}>
                <InputWrapper>
                  <Input
                    type="text"
                    value={inputValue}
                    onChange={(e: any) => setInputValue(e.target.value)}
                    onKeyPress={handleInputKeyUp}
                  />
                  <span className="save">
                    <img src={TickNormal} alt="save" onClick={saveMethod} />
                  </span>
                  <span className="cancel">
                    <img src={crossNormal} alt="cancel" onClick={cancelMethod} />
                  </span>
                </InputWrapper>
              </div>
            ) : (
              <>
                <DraftTitle>
                  <div className="subject-line">
                    {
                      <Tooltip placement="top" title={ellipsisState ? props.draftTitle : undefined}>
                        <Paragraph ellipsis={{ rows: 2, onEllipsis: setEllipsistate }}>
                          <>{props.draftTitle}</>
                        </Paragraph>
                      </Tooltip>
                    }
                  </div>
                  <span
                    className="edit-margin-top cursor-pointer padding-left-xs edit-icon-style"
                    onClick={(e) => setEditModeMethod(e)}
                  >
                    <img src={EditIcon} alt="edit" />
                  </span>
                </DraftTitle>
              </>
            )}
          </>
        )}
      </div>
      {props.assetType === ASSET_TYPE.HYBRID && (
        <CuratedArticlesCountViewer>
          <OvalNumber>
            <span className="text-white font-weight-bold">{props.curatedArticlesCount}</span>
          </OvalNumber>
          <CuratedArticle>Curated articles</CuratedArticle>
        </CuratedArticlesCountViewer>
      )}
    </div>
  );
}

const DraftTitle = styled.span`
  display: flex;
  align-items: baseline;
  .edit-icon-style {
    /* margin-bottom: 18px; */
    margin-left: 6px;
  }
  .subject-line {
    font-family: "Roboto Slab", serif;
    color: #000000;
    line-height: 30px;
    font-size: 26px;
    font-weight: 600;
    height: 60px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 30px);
    float: left;
    word-break: break-all;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 18px;
      line-height: 20px;
      height: 40px;
    }
  }
`;
const DraftName = styled.span`
  color: #27ce0a;
  font-family: "robotomedium", sans-serif;
  font-weight: 400;
  font-size: 14px;
  margin-top: 13px;
  width: 100%;
  max-height: 42px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    font-size: 12px;
    max-height: 18px;
  }
`;
const CuratedArticle = styled.p`
  color: #7e7e7e;
  font-size: 14px;
  font-family: "robotomedium", sans-serif;
  font-weight: 400;
  margin-left: 7px;
  margin-top: 5px;
  margin-bottom: 0;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    font-size: 13px;
    margin-top: 1px;
  }
`;
const OvalNumber = styled.div`
  background: #27ce0a;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    font-size: 13px;
    width: 22px;
    height: 22px;
  }
`;
const CuratedArticlesCountViewer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    margin-top: 8px;
  }
`;
const InputWrapper = styled.div`
  position: relative;
  top: 0;
  left: 0;
  margin-right: 10px;
  label {
    display: none;
  }
  input {
    padding-right: 70px;
    width: 100%;
  }
  .save {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      top: 5px;
    }
    img {
      vertical-align: middle;
      max-width: 20px;
    }
  }
  .cancel {
    position: absolute;
    top: 10px;
    right: 40px;
    cursor: pointer;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      top: 5px;
    }
    img {
      vertical-align: middle;
      max-width: 20px;
      padding: 2px;
    }
  }
`;
